import {Model} from '@vuex-orm/core';
import UnitPlanOa from '../planner/objetive/UnitPlanOa';
import School from '../commons/School';
import UnitPlanAttitude from '../planner/purpose/UnitPlanAttitude';
import UnitPlanSkill from '../planner/purpose/UnitPlanSkill';
import Attitude from '../planner/purpose/Attitude';
import PreLearning from '../planner/purpose/PreLearning';
import Skill from '../planner/purpose/Skill';
import UnitPlanWeek from '../planner/coverage/UnitPlanWeek';
import UnitPlanComments from './UnitPlanComments';
import {IUnitPlan} from '../../interfaces/units/IUnitPlan';

// @ts-ignore
export default class UnitPlan extends Model implements IUnitPlan {

    static entity = 'unit_plans';

    static fields () {
        return {
            id: this.number(0),
            id_plan: this.number(0),
            school_id: this.number(0),
            userIdPersona: this.number(0),
            name1: this.string(''),
            name2: this.string(''),
            nombre_plan: this.string(''),
            status_plan: this.string(''),
            priority: this.string('').nullable(),
            planType: this.number(1),
            classDays: this.attr(null),
            editing_status_id: this.attr(null),
            plan_status_id: this.attr(null),
            hours: this.string(''),
            cod_unidad: this.string(''),
            startDate: this.string('').nullable(),
            endDate: this.string('').nullable(),
            teacher: this.string('').nullable(),
            //year: this.attr(''),// this.number(new Date().getFullYear()), // period
            description: this.string('').nullable(), // Proposito
            oa_count: this.number(0),
            activity_count: this.number(0),
            comments_count: this.number(0),
            plannedCurricularPercentage: this.attr(null),
            doneCurricularPercentage: this.attr(null),
            totalIesDefined: this.attr(null),
            totalIesPlanned: this.attr(null),
            totalIesDone: this.attr(null),
            itemsPlannedPercentage: this.attr(null),
            itemsDonePercentage: this.attr(null),
            unitPlanOrigin_id: this.attr(null),

            // Solo por compatibilidad
            state: this.number(0),
            subject: this.attr(''),
            schoolLevel: this.attr(''),
            educationLevel: this.attr(''),
            level: this.attr(''),
            course: this.attr(''),
            levelAb: this.attr(''),
            // Endpoint
            asignatura: this.string(''),
            hasCoverage: this.boolean(false),
            id_asignatura: this.number(0),
            id_unidad: this.number(0),
            id_nivel: this.number(0),
            id_seccion: this.number(0),

            // Aqui estan las relaciones de modelo que estan funcionando
            school: this.belongsTo(School, 'school_id'),
            comments: this.hasMany(UnitPlanComments, 'idPlanUnidad'),
            oas: this.hasMany(UnitPlanOa, 'unitplan_id'),
            //Otros
            coverage: this.hasMany(UnitPlanWeek, 'unitplan_id'),
            preLearnings: this.hasMany(PreLearning, 'unitplan_id'),
            skills: this.belongsToMany(Skill, UnitPlanSkill, 'unitplan_id', 'skill_id'),
            attitudes: this.belongsToMany(Attitude, UnitPlanAttitude, 'unitplan_id', 'attitude_id'),

            // Activities
            // activities: this.hasMany(UnitPlanActivity, 'unitplan_id'),
        };
    }

    get year(){
        return this.nombre_plan;
    }

    get duration() {
        let h: string | number;
        let m: string | number;

        h = 0;
        m = 0;

        const details = UnitPlanOa.
                            query().
                            where('unitplan_id',
                                // @ts-ignore
                                this.id).
                            where('disabled', false).
                            get();

        // @ts-ignore
        const hours = details.map(item => item.hours);

        for (let i = 0; i < hours.length; i++) {
            let arr = hours[i].split(':');
            h += parseInt(arr[0]);
            m += parseInt(arr[1]);
            h += Math.floor(m / 60) ;
            m = m % 60;
        }

        if (isNaN(h) && isNaN(m)) {
            h = "00";
            m = "00";
        }

        return h + 'h:' + m + 'm';
    }

    public updateStatus(status: any) {
        // @ts-ignore
        this.status_plan = status.status_plan;
        // @ts-ignore
        this.editing_status_id = status.editing_status_id;
        // @ts-ignore
        this.plan_status_id = status.plan_status_id;
    }

    public updatePercentages(percentages: any) {
        // @ts-ignore
        this.plannedCurricularPercentage = percentages.porcentajeCurricularPlanificado;
        // @ts-ignore
        this.doneCurricularPercentage = percentages.porcentajeCurricularRealizado;
        // @ts-ignore
        this.itemsPlannedPercentage = percentages.porcentajeItemsPlanificado;
        // @ts-ignore
        this.itemsDonePercentage = percentages.porcentajeItemsRealizado;
        // @ts-ignore
        this.totalIesDefined = percentages.iesTotalDefinido;
        // @ts-ignore
        this.totalIesPlanned = percentages.iesTotalPlanificado;
        // @ts-ignore
        this.totalIesDone = percentages.iesTotalRealizado;

        this.$save();
    }

    public updateOaCount(newValue: number) {
        // @ts-ignore
        this.oa_count = newValue;
        this.$save();
    }


}
